import styles from './main-structures-detail.module.css';
import React from 'react';
import { Button, CloseButton, Icon } from '../../../../components';
import MainStructuresDetailField from './components/MainStructuresDetailField/MainStructuresDetailField';
import { Icons } from '../../../../components/Icon/Icon';

interface MainStructuresDetailProps {
    activeInvestment: any;
    onClose: any;
}

const MainStructuresDetail = ({ activeInvestment, onClose }: MainStructuresDetailProps) => {
    const legalForms = activeInvestment?.ribbons.map((r: any) => r.to);

    return (
        <>
            {activeInvestment && (
                <div className={styles.boxOuter}>
                    <div className={styles.box}>
                        <div className={styles.closeBtnWrapper}>
                            <button type={'button'} onClick={() => onClose()}>
                                <Icon icon={Icons.close} />
                            </button>
                        </div>

                        <h5 className={styles.fundTitle}>Investment fund</h5>
                        <p className={styles.fundTitleFN}>{activeInvestment.data.fullName}</p>
                        <div className={styles.data}>
                            <MainStructuresDetailField title={'Domicile'} value={activeInvestment.data.domicileName} />
                            <MainStructuresDetailField
                                title={'Regulation'}
                                value={activeInvestment.data.regulationType}
                            />
                            {activeInvestment.data.applicableTax && (
                                <MainStructuresDetailField
                                    title={'Tax status'}
                                    value={activeInvestment.data.applicableTax.replace(/\w\S*/g, (w: any) =>
                                        w.replace(/^\w/, (c: any) => c.toUpperCase()),
                                    )}
                                />
                            )}
                            <MainStructuresDetailField
                                title={'Level of regulation'}
                                value={activeInvestment.data.levelOfRegulation.replace(/\w\S*/g, (w: any) =>
                                    w.replace(/^\w/, (c: any) => c.toUpperCase()),
                                )}
                            />

                            <MainStructuresDetailField
                                title={'Asset manager'}
                                value={activeInvestment.data.assetManagerToShow}
                            />
                            <MainStructuresDetailField
                                title={'Complexity'}
                                value={activeInvestment.data.regulationComplexity}
                            />
                            <MainStructuresDetailField
                                title={'If AIF'}
                                value={activeInvestment.data.ifAif
                                    .toString()
                                    .replace(/\w\S*/g, (w: any) => w.replace(/^\w/, (c: any) => c.toUpperCase()))}
                                useCheckbox={true}
                                // info={'Alternative Investment Fund'}
                            />
                            <MainStructuresDetailField
                                title={'Max shareholders'}
                                value={activeInvestment.data.maxNumOfShareholders}
                            />

                            <MainStructuresDetailField
                                title={'Tax status'}
                                value={`${activeInvestment.data.taxStatus}`}
                                footnote={3}
                            />
                            <MainStructuresDetailField
                                title={'Cost to launch'}
                                value={`$${activeInvestment.data.costsToLaunchUsdFormated}`}
                                footnote={1}
                            />

                            <MainStructuresDetailField
                                title={'Annual cost for $100m'}
                                value={`$${activeInvestment.data.annualCostsFormated}`}
                                footnote={2}
                            />
                        </div>

                        <div className={styles.borderDataTop}>
                            <h5 className={styles.fieldHeader}>Legal form</h5>
                            <h5 className={styles.fieldHeader}>
                                Days to launch <span className={styles.footnote}>2</span>
                            </h5>
                        </div>
                        {legalForms.map((lf: any, key: any) => (
                            <div key={key} className={styles.borderData}>
                                <span>{lf.name}</span>
                                <span>
                                    {
                                        lf.launchBubbles.find((lb: any) => lb.investmentFund === activeInvestment.name)
                                            .costRange
                                    }
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default MainStructuresDetail;
